import { HIDE_SCAN_TOOLTIP, SHOW_SCAN_TOOLTIP } from "./types"

export const hideToolTip = () => dispatch => {
    dispatch({ type: HIDE_SCAN_TOOLTIP, payload: { showScanTooltip: false }})
}

export const showScanTooltip = () => dispatch => {
    dispatch({ type: SHOW_SCAN_TOOLTIP, payload: { showScanTooltip: true }})
}